import { render, staticRenderFns } from "./ConfigAcademic.vue?vue&type=template&id=37748fd6"
import script from "./ConfigAcademic.vue?vue&type=script&lang=js"
export * from "./ConfigAcademic.vue?vue&type=script&lang=js"
import style0 from "./ConfigAcademic.vue?vue&type=style&index=0&id=37748fd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports